import { transport } from 'config/transport';

export function callApiCreateDanhMucThu(congDoanId, body) {
    return transport.post(`/mamnon/${congDoanId}/thuhocsinh/danhmucthu`, body);
}
